import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";

const useAssignOrderToCourier = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const assign = async (data) => {
		const instance = await InitApi({ accessToken });
		const body = deleteEmptyObjects(data);
		const res = await instance.post("/orders/assign-courier", body);
		await queryClient.invalidateQueries("orders");
		return res.data;
	};

	return useMutation(assign, {
		onSuccess: async (body) => {
			toast.success(body.message);
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useAssignOrderToCourier;
